import React, { useState, useEffect } from "react";
import { Building2, Award, Users, Clock, CheckCircle } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const About = () => {
  const [aboutInfo, setAboutInfo] = useState({
    experience: "40+ ans",
    projects_count: "100+",
    description: "Passionné par le bâtiment depuis plus de 40 ans, j'accompagne particuliers et professionnels dans la réalisation de leurs projets.",
    mission: "Ma mission est de vous offrir un accompagnement personnalisé, transparent et de qualité.",
    expertise_areas: [],
    trust_reasons: []
  });
  const [contactInfo, setContactInfo] = useState({ name: "nous" });

  useEffect(() => {
    const loadData = async () => {
      try {
        // Ajouter un petit délai pour laisser le backend démarrer
        await new Promise(resolve => setTimeout(resolve, 300));
        const [aboutResponse, contactResponse] = await Promise.all([
          axios.get(`${API}/public/about`),
          axios.get(`${API}/public/contact-info`)
        ]);
        if (aboutResponse.data) setAboutInfo(aboutResponse.data);
        if (contactResponse.data) setContactInfo(contactResponse.data);
      } catch (error) {
        console.error("Erreur lors du chargement des données:", error);
        // Garder les valeurs par défaut en cas d'erreur
      }
    };
    
    if (API && API !== 'undefined/api') {
      loadData();
    }
  }, []);

  const stats = [
    {
      icon: <Clock className="w-8 h-8 text-blue-900" />,
      value: aboutInfo.experience,
      label: "d'expérience"
    },
    {
      icon: <Building2 className="w-8 h-8 text-blue-900" />,
      value: aboutInfo.projects_count,
      label: "projets réalisés"
    },
    {
      icon: <Award className="w-8 h-8 text-blue-900" />,
      value: "100%",
      label: "clients satisfaits"
    },
    {
      icon: <Users className="w-8 h-8 text-blue-900" />,
      value: "5★",
      label: "note moyenne"
    }
  ];

  return (
    <section id="a-propos" className="py-12 relative">
      {/* Image de fond */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=2076&q=80')"
        }}
      ></div>
      {/* Overlay semi-transparent */}
      <div className="absolute inset-0 bg-white/85"></div>
      {/* Contenu */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                À propos de{" "}
                <span className="text-blue-900">nous</span>
              </h2>
              <div className="text-lg text-gray-600 leading-relaxed mb-8 space-y-4">
                <p>
                  Fort de plus de 40 ans d'expérience dans le secteur du bâtiment, j'ai découvert ce métier dans le cadre d'une entreprise familiale, ce qui m'a permis d'acquérir une connaissance approfondie des différents corps de métier.
                </p>
                <p>
                  Au fil des années, j'ai participé à de nombreux projets, aussi bien en rénovation intérieure et extérieure que dans d'autres domaines du bâtiment, en alliant exigence technique et sens du détail.
                </p>
                <p>
                  Aujourd'hui, je mets cette expérience globale au service de mes clients pour leur offrir un accompagnement personnalisé, fiable et transparent.
                </p>
              </div>
              <div className="mt-8 pt-4 flex justify-end">
                <p className="text-3xl text-gray-800" style={{
                  fontFamily: 'Caveat, cursive',
                  fontWeight: '600',
                  textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
                  letterSpacing: '1px'
                }}>
                  François Meriggioli
                </p>
              </div>
            </div>
          </div>
      
            {/* Colonne droite: Carte "Pourquoi me faire confiance ?" rétablie */}
            <div>
              <div className="bg-blue-50 rounded-xl p-8 border border-blue-100 shadow-sm">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  Pourquoi me faire confiance ?
                </h3>
                <div className="space-y-4">
                  {[
                    "Premier échange gratuit et sans engagement",
                    "Réponse sous 48h",
                    "Accompagnement personnalisé et transparent",
                    "Respect des budgets et des délais"
                  ].map((item, idx) => (
                    <div key={idx} className="flex items-start space-x-3">
                      <CheckCircle className="w-5 h-5 text-blue-900 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default About;